import script from "./NoviceFilterChip.vue?vue&type=script&setup=true&lang=js"
export * from "./NoviceFilterChip.vue?vue&type=script&setup=true&lang=js"

import "./NoviceFilterChip.vue?vue&type=style&index=0&id=9bd2ec6a&scoped=true&lang=css"
import "./NoviceFilterChip.vue?vue&type=style&index=1&id=9bd2ec6a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bd2ec6a"]])

export default __exports__